import React, { FC } from 'react';
import { CampinasDecor02, Project1Image, Project2Image, Project3Image, ResidenciaAj01, ResidenciaColina01 } from '~/assets/images';

import {
  Button,
  ButtonWrapper,
  Image,
  ImageDownWrapper,
  ImageLeftWrapper,
  ImageRightWrapper,
  ImageWrapper,
  Text,
  TextAnimation,
  TextWrapper,
  Title,
  Wrapper,
} from './styles';

type Props = {
  onProjects: () => void;
};

const ProjectSection: FC<Props> = ({ onProjects }) => {
  return (
    <Wrapper>
      <TextWrapper>
        <TextAnimation>
          <Title>Projetos</Title>
          <Text>Conheça nossos últimas criações</Text>
        </TextAnimation>
        <ImageWrapper>
          <ImageLeftWrapper>
            <Image src={CampinasDecor02} />
          </ImageLeftWrapper>
          <ImageDownWrapper>
            <Image src={ResidenciaColina01} />
          </ImageDownWrapper>
          <ImageRightWrapper>
            <Image src={ResidenciaAj01} />
          </ImageRightWrapper>
        </ImageWrapper>
      </TextWrapper>
      <ButtonWrapper>
        <Button onPress={onProjects} hasBorder>
          Ver Mais
        </Button>
      </ButtonWrapper>
    </Wrapper>
  );
};

export default ProjectSection;
